import './App.css';
import Home from './Home'
import Header from './Header'
import Footer from './Footer'
import TermsPage from './TermsPage'
import Support from './Support'

import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

function App() {
  return (
    <div className="app">
      <Router>
        <Header />

          <Switch>
            <Route path="/terms">
              <TermsPage />
            </Route>

            <Route path="/privacy">
              <Home />
            </Route>

              <Route path="/support">
                <Support />
              </Route>
            </Switch>

        <Footer />
      </Router>
  </div>
  );
}

export default App;
